import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {PaymentInfo} from '../../models/ApplicationModel';

@Component({
  selector: 'app-application-declaration-letter',
  templateUrl: './application-declaration-letter.component.html',
  styleUrls: ['./application-declaration-letter.component.css']
})
export class ApplicationDeclarationLetterComponent implements OnInit {
  public agree = false;
  @Output('applicantAgreesWithDeclaration') applicantAgreesWithDeclarationEvent: EventEmitter<Boolean> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  checkboxValueChanged() {
    this.agree = !this.agree;
    this.applicantAgreesWithDeclarationEvent.emit(this.agree);
  }


}
